import { AnyAction } from 'redux'
import { all, call, put, select, takeEvery } from 'redux-saga/effects'
import { AppState } from 'redux/config/store'
import { autoInviteActions } from './autoInviteSlice'
import AutoInviteService from './autoInviteService'
import { AutoInviteRule } from './autoInviteTypes'

export function* getAutoInviteRuleSaga(_action: AnyAction) {
  try {
    const res = yield call(AutoInviteService.getAutoInviteRules)
    yield put(
      autoInviteActions.getAutoInviteRuleSuccess((res.data ?? []) as AutoInviteRule[])
    )
  } catch {
    yield put(autoInviteActions.getAutoInviteRuleFailed())
  }
}

export function* saveAutoInviteRuleSaga(_action: AnyAction) {
  yield put(autoInviteActions.setSaveLoading(true))
  try {
    const rule: AutoInviteRule | null = yield select(
      (s: AppState) => s.autoInvite.rule
    )
    if (!rule?.id) {
      yield put(autoInviteActions.saveAutoInviteRuleFailed())
      return
    }
    const res = yield call(
      AutoInviteService.modifyAutoInviteRule,
      rule.id,
      rule
    )
    yield put(autoInviteActions.saveAutoInviteRuleSuccess(res.data))
  } catch {
    yield put(autoInviteActions.saveAutoInviteRuleFailed())
  }
}

export function* watchGetAutoInviteRule() {
  yield takeEvery(autoInviteActions.getAutoInviteRule.type, getAutoInviteRuleSaga)
}

export function* watchSaveAutoInviteRule() {
  yield takeEvery(
    autoInviteActions.saveAutoInviteRule.type,
    saveAutoInviteRuleSaga
  )
}

export default function* autoInviteSaga() {
  yield all([watchGetAutoInviteRule(), watchSaveAutoInviteRule()])
}
